import HistoryRow from 'Components/HistoryRow';
import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { sortDocumentsDescending } from 'Utility/documentHandling';
import { isNil } from 'Utility/ramdaReplacement';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'parkinsonSymptoms'>[] = [];
const ParkinsonSymptoms = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'parkinsonSymptoms'>>): React.JSX.Element => {
  const parkinsonSymptoms = documents.toSorted(sortDocumentsDescending).at(0);

  return (
    <HistoryRow
      headerText={fm('diagnosis.parkinsonSymptoms')}
      rowButton={
        startEdit
          ? newButton(
              'parkinsonSymptoms',
              startEdit(parkinsonSymptoms ?? {}, 'parkinsonSymptoms'),
              'general.edit',
              undefined,
              undefined,
              !isNil((parkinsonSymptoms ?? {})._lockedFor),
              undefined,
              undefined,
              parkinsonSymptoms,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(parkinsonSymptoms)}
    >
      <React.Fragment>
        <HistoryRowVerticalItem
          header={fm('general.date')}
          value={parkinsonSymptoms?.symptomOnsetDate ? formatPartialDate(parkinsonSymptoms.symptomOnsetDate) : ' - '}
        />
        <HistoryRowVerticalItem
          header={fm('diagnosis.parkinsonEarlySymptom.title')}
          value={
            parkinsonSymptoms?.parkinsonEarlySymptom && parkinsonSymptoms.parkinsonEarlySymptom.length > 0
              ? parkinsonSymptoms.parkinsonEarlySymptom.map(s => fm(`diagnosis.parkinsonEarlySymptom.${s}`))
              : '-'
          }
        />
        <HistoryRowVerticalItem
          header={fm('diagnosis.parkinsonSymptomOnsetOther')}
          value={
            parkinsonSymptoms?.parkinsonSymptomOnsetOther && parkinsonSymptoms.parkinsonSymptomOnsetOther.length > 0
              ? parkinsonSymptoms.parkinsonSymptomOnsetOther
              : ' - '
          }
        />
        <HistoryRowVerticalItem
          header={fm('diagnosis.parkinsonMotoricSymptomOnset.title')}
          value={fm(
            `diagnosis.parkinsonMotoricSymptomOnset.${
              parkinsonSymptoms?.parkinsonMotoricSymptomOnset
                ? 'opts.' + parkinsonSymptoms.parkinsonMotoricSymptomOnset
                : 'empty'
            }`,
          )}
        />
        {parkinsonSymptoms?.parkinsonMotoricSymptomOnset === 'other' && (
          <HistoryRowVerticalItem
            header={fm('diagnosis.parkinsonMotoricSymptomOnset.otherSymptom')}
            value={parkinsonSymptoms.parkinsonMotoricSymptomOnsetOtherSymptom}
          />
        )}
        <HistoryRowVerticalItem
          header={fm('diagnosis.parkinsonMotoricSymptomOnsetSide.title')}
          value={fm(
            `diagnosis.parkinsonMotoricSymptomOnsetSide.${
              parkinsonSymptoms?.parkinsonMotoricSymptomOnsetSide
                ? 'opts.' + parkinsonSymptoms.parkinsonMotoricSymptomOnsetSide
                : 'empty'
            }`,
          )}
        />
        <HistoryRowVerticalItem
          header={fm('diagnosis.parkinsonMotoricSymptomOnsetInfo')}
          value={parkinsonSymptoms?.parkinsonMotoricSymptomOnsetInfo ?? ' - '}
        />
      </React.Fragment>
    </HistoryRow>
  );
};

export default ParkinsonSymptoms;
